"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fitToScreen = void 0;
const three_1 = require("three");
const DISTANCE_FACTOR = 10;
function fitToScreen(model, camera, orbitControls) {
    const boxHelper = new three_1.BoxHelper(model);
    boxHelper.geometry.computeBoundingSphere();
    const boundingSphere = boxHelper.geometry.boundingSphere;
    if (!boundingSphere)
        throw new Error("Bounding sphere is undefined");
    boxHelper.geometry.computeBoundingBox();
    const boundingBox = boxHelper.geometry.boundingBox;
    if (!boundingBox)
        throw new Error("Bounding box is undefined");
    const size = new three_1.Vector3();
    boundingBox.getSize(size);
    const cameraDistance = calculateCameraDistance(size, camera);
    const cameraHeight = calculateCameraHeight(boundingBox);
    const sphereRadius = boundingSphere.radius;
    const minZ = boundingBox.min.z;
    const cameraToFarEdge = Math.abs((minZ < 0) ? (-minZ + cameraDistance) : (cameraDistance - minZ));
    const camPosition = new three_1.Vector3(0, cameraHeight, cameraDistance);
    camera.position.copy(camPosition);
    camera.lookAt(boundingSphere.center);
    adjustClippingPlanesToSphere(sphereRadius, cameraToFarEdge, camera);
    orbitControls.target.copy(boundingSphere.center);
    orbitControls.maxDistance = cameraToFarEdge * DISTANCE_FACTOR;
    PubSub.publish("initial-position-set" /* INITIAL_POSITION_SET */, { cameraPosition: camPosition, orbitTarget: boundingSphere.center });
    boxHelper.geometry.dispose();
}
exports.fitToScreen = fitToScreen;
function calculateCameraDistance(size, camera) {
    const fov = camera.fov * (Math.PI / 180);
    const fovh = 2 * Math.atan(Math.tan(fov / 2) * camera.aspect);
    const dx = size.z / 2 + Math.abs(size.x / 2 / Math.tan(fovh / 2));
    const dy = size.z / 2 + Math.abs(size.y / 2 / Math.tan(fov / 2));
    const distance = Math.max(dx, dy);
    return distance;
}
function adjustClippingPlanesToSphere(radius, cameraToFarEdge, camera) {
    if (radius < 10.0) {
        camera.near = 0.01;
    }
    else if (radius < 100.0) {
        camera.near = 0.1;
    }
    else if (radius < 1000.0) {
        camera.near = 10.0;
    }
    else {
        camera.near = 100.0;
    }
    camera.far = cameraToFarEdge * (DISTANCE_FACTOR + 1);
    camera.updateProjectionMatrix();
}
function calculateCameraHeight(boundingBox) {
    const offset = 0.1;
    const modelHeight = boundingBox.max.y - boundingBox.min.y;
    const cameraHeight = modelHeight + (modelHeight * offset);
    return cameraHeight;
}
